import { render, staticRenderFns } from "./AttachmentFilesList.vue?vue&type=template&id=774b2f5b&"
import script from "./AttachmentFilesList.vue?vue&type=script&lang=js&"
export * from "./AttachmentFilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports